import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import FontLoader from 'yoda-core-components/lib/helpers/FontLoader/FontLoader';
import classNames from 'classnames/bind';
import FeatureFlag from 'yoda-core-components/lib/components/FeatureFlag/FeatureFlag';
import * as styles from './Layout.css';
import AppBanner from '../AppBanner/AppBanner';
import DevToolBarLazy from '../../helpers/DevToolBar/DevToolBarLazy';
import DateTimePickerLazy from '../DateTimePicker/DateTimePickerLazy';
import { selectShouldRender } from '../../selectors/ContextSelector';
import getExternalComponent from '../../externalize/Externalize';
import Header from '../YodaHeader/Header';
import Footer from '../YodaFooter/HeaderChunksAndFooterLazy';
import SignInSliderConnectLazy from '../SignInSlider/SignInSliderConnectLazy';
import FindStoresLazy from '../FindStores/FindStoresLazy';

const cx = classNames.bind(styles);

const defaults = {
    signInSliderDetails: {
        openSignInSlider: false,
        openCreateAccount: false,
        openLogoutSlider: false,
    },
};

export class Layout extends PureComponent {
    static defaultProps = {
        hideHeader: false,
        hideFooter: false,
        disableWhiteBG: null,
        deviceType: {},
        requestUrl: '',
        baseName: '',
        showOverlay: false,
        isPreview: false,
        signInSliderDetails: defaults.signInSliderDetails,
        hideSubscription: false,
        shouldRender: true,
        renderRecZone: noop,
        layoutArticleClass: '',
        showBlurBG: false,
        showGlobalLoader: false,
        featureFlags: {},
        productSearchFocus: '',
        isNative: false,
        checkoutProps: {},
    };

    static propTypes = {
        children: PropTypes.element.isRequired,
        hideHeader: PropTypes.bool,
        hideFooter: PropTypes.bool,
        disableWhiteBG: PropTypes.bool,
        deviceType: PropTypes.object,
        requestUrl: PropTypes.string,
        baseName: PropTypes.string,
        showOverlay: PropTypes.bool,
        isPreview: PropTypes.bool,
        signInSliderDetails: PropTypes.object,
        hideSubscription: PropTypes.bool,
        shouldRender: PropTypes.bool,
        renderRecZone: PropTypes.func,
        layoutArticleClass: PropTypes.string,
        showBlurBG: PropTypes.bool,
        showGlobalLoader: PropTypes.bool,
        productSearchFocus: PropTypes.string,
        isNative: PropTypes.bool,
        featureFlags: PropTypes.object,
        checkoutProps: PropTypes.object,
    };

    static contextTypes = {
        isFusionEnabled: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.state = {};
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        PropTypes.shape({
            openSignInSlider: PropTypes.bool,
            openCreateAccount: PropTypes.bool,
            openLogoutSlider: PropTypes.bool,
        });
    }

    componentDidMount() {
        try {
            const fontsList = [
                { fontname: 'Open Sans', weight: '400', style: 'normal' },
                { fontname: 'Open Sans', weight: '700', style: 'normal' },
                { fontname: 'Open Sans', weight: '400', style: 'italic' },
            ];
            new FontLoader().callToLoadFonts(fontsList, styles);
        } catch (e) {
            // Log the error
        }
        this.setDevToolBar();
        this.setRewardsIndicator();
    }

    setDevToolBar = () => {
        try {
            const jcpTester = window.location.search.indexOf('jcptester=true') !== -1;
            const jcpTesterCookie = Cookies.load('jcptester') || '';
            if (jcpTester || jcpTesterCookie === 'true') {
                this.setState({ displayDevToolBar: true });
            }
        } catch (error) {
            console.log('Error ', error);
        }
    };

    setRewardsIndicator = () => {
        const rewardsPilot = Cookies.load('eligibleForRewardsPilot') || false;
        if (rewardsPilot) {
            this.setState({ rewardsPilotIndicator: true });
        }
    };

    getHeaderComponent() {
        const { hideHeader, checkoutProps } = this.props;
        if (hideHeader) {
            return null;
        }
        const props = {
            mountOnServer: true,
            checkoutProps,
        };
        const headerData = getExternalComponent('header', props);

        // eslint-disable-next-line react/jsx-props-no-spreading
        return process.env.ENV === 'aws' ? headerData : <Header {...props} />;
    }

    getSignInSliderComponent = () => {
        const { signInSliderDetails } = this.props;
        const { mountSignInSlider } = signInSliderDetails || {};
        if (mountSignInSlider) {
            if (process.env.ENV === 'aws') {
                return getExternalComponent('signInSlider');
            }
            return <SignInSliderConnectLazy />;
        }
        return null;
    };

    renderFindStoresComponent = () => {
        const { findAStoreSliderProps } = this.props;
        /* istanbul ignore else */
        if (process.env.ENV === 'aws') {
            return getExternalComponent('findStoresSlider', findAStoreSliderProps);
        }
        return <FindStoresLazy {...findAStoreSliderProps} />;
    };

    footerContent = () => {
        const { hideFooter, hideSubscription, renderRecZone } = this.props;
        if (hideFooter) {
            return null;
        }
        const props = {
            expandedFooter: true,
            hideSubscription,
            renderRecZone,
        };
        const footerData = getExternalComponent('footer', props);
        // eslint-disable-next-line react/jsx-props-no-spreading
        return process.env.ENV === 'aws' ? footerData : <Footer {...props} />;
    };

    render() {
        const {
            deviceType,
            showOverlay,
            showGlobalLoader,
            isPreview,
            shouldRender,
            layoutArticleClass,
            productSearchFocus,
            isNative,
            disableWhiteBG,
            showBlurBG,
            requestUrl,
            baseName,
            findAStoreSliderProps,
        } = this.props;
        /* istanbul ignore next */
        const headerComponent = this.getHeaderComponent();
        /**
         * MCYODA-20881 => This is to show custom loader based on cart and checkout requirement,
         */
        const showLoader = showGlobalLoader ? 'progress-active' : '';
        if (!shouldRender) {
            return (
                <>
                    {headerComponent}
                    <article
                        className={cx('contentContainer', 'containerWidth', layoutArticleClass)}
                    >
                        {this.props.children}
                    </article>
                </>
            );
        }

        // If Fusion Application is enabled, the FeaturePermission will return the module loader & module names.
        const { displayDevToolBar, rewardsPilotIndicator } = this.state;

        /* For the issue MNPDPYODA-2467. In future have to work on make it responsive */
        const blurClass = showBlurBG ? 'blurBg' : '';
        const lockWidthCss = deviceType.isDesktop ? 'lockWidth' : '';
        const backgroundCss = disableWhiteBG ? '' : 'whiteBg';
        const mainClass = cx('mainContainer', lockWidthCss, backgroundCss, blurClass);
        const previewClass = isPreview ? cx('previewActive') : cx('');
        let overlay = cx('overlay');
        if (showOverlay || showBlurBG) {
            overlay = cx('overlay', 'active');
        }
        const containerWidth = requestUrl === '/' && baseName === '/' ? '' : 'containerWidth';
        const previewMainHeaderClass = isPreview && cx('previewHeaderMainBlock');
        // MNPDPYODA-2467 Ends
        return (
            <main
                id="mainContainerBlock"
                data-automation-id="mainContainerBlock"
                className={cx(mainClass, previewClass, showLoader, previewMainHeaderClass)}
            >
                {isPreview && <DateTimePickerLazy showDateTimePicker />}
                <div
                    id={rewardsPilotIndicator ? 'eligible-for-rewards-pilot' : ''}
                    className={overlay}
                />
                {!isNative && (
                    <FeatureFlag name="appBanner">
                        <div className={styles.noMargin}>
                            <AppBanner />
                        </div>
                    </FeatureFlag>
                )}
                {headerComponent}
                <article
                    id="contentContainer"
                    className={cx(
                        'contentContainer',
                        containerWidth,
                        layoutArticleClass,
                        productSearchFocus
                    )}
                >
                    {this.props.children}
                </article>
                {this.getSignInSliderComponent()}
                {!isEmpty(findAStoreSliderProps) && this.renderFindStoresComponent()}
                {!isNative && this.footerContent()}
                {/* {!this.props.hideFooter && <YodaFooter expandedFooter />} */}
                {displayDevToolBar && <DevToolBarLazy />}
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    showOverlay: state.showOverlay,
    showGlobalLoader: state.showGlobalLoader,
    isPreview: state.context ? state.context.isPreview : false,
    signInSliderDetails: state.signInSliderDetails,
    shouldRender: selectShouldRender(state),
    productSearchFocus: state.productSearchFocus,
    isNative: state.context ? state.context.isNative : false,
    requestUrl: state.context && state.context.requestUrl,
    baseName: state.context && state.context.baseName,
    findAStoreSliderProps: state.findAStoreSliderProps,
});

export default connect(mapStateToProps)(Layout);
